jQuery(function ($) {
	var headerHeight = 0;
	$('a[href^="#"]').click(function () {
		var href = $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		if (target.length > 0) {
			var position = target.offset().top - headerHeight;
			$("html, body").animate({ scrollTop: position }, 550, "swing");
			return false;
		}
	});
})
jQuery(function ($) {
	$(window).on("load", function () {

		if (window.location.hash) {
			const target = $(window.location.hash);
			if (target.length) {
				setTimeout(function () {
					$("html, body").animate({
						scrollTop: target.offset().top - 80
					}, 300);
				}, 300);

			}
		}

	});
});
jQuery(function ($) {
	const backTop = $(".js-backTop");
	$(window).on("scroll", function () {
		if ($(this).scrollTop() > 300) {
			backTop.addClass("is-show");
		} else {
			backTop.removeClass("is-show");
		}
	});

	backTop.on("click", function () {
		$("html, body").animate({
			scrollTop: 0
		}, 600);
	});

});


jQuery(function ($) {
	$('.p-faqList__question').on('click', function () {
		const $this = $(this);

		$this.toggleClass('is-active');

		$this
			.next('.p-faqList__answer')
			.stop()
			.slideToggle(300);

	});

});

jQuery(function ($) {
	if ($('#toggle').length > 0) {
		$('#toggle').click(function () {
			$(this).toggleClass('toggle_active');
			$('#drawer_layer').fadeToggle();
			$('body').toggleClass('drawer_open');

			if ($(this).hasClass('toggle_active')) {
				$('nav').addClass('is_open');
				$('nav').removeClass('is_close');
			} else {
				$('nav').removeClass('is_open');
				$('nav').addClass('is_close');
			}
		});

		$('#drawer_layer').click(function () {
			$(this).fadeOut();
			$('#toggle').removeClass('toggle_active');
			$('body').removeClass('drawer_open');
			$('nav').removeClass('is_open');
			$('nav').addClass('is_close');
		});

		$('nav a').on('click', function () {
			if ($('#toggle:visible').length > 0) {
				$('#toggle').click();
			}
		});
	}

});

jQuery(function ($) {
	let submitBtn = $("input[type='submit'].wpcf7-submit");
	submitBtn.click(function () {
		$(this).css('pointer-events', 'none');
		$(this).css('opacity', '0.5');
	})
	document.addEventListener('wpcf7invalid', function () {
		submitBtn.css('pointer-events', 'auto');
		submitBtn.css('opacity', '1');
	}, false);

});

jQuery(function ($) {

	$("body").css("overflow", "hidden");

	// =========================
	// LOADING
	// =========================
	$(window).on("load", function () {
		setTimeout(function () {
			$(".p-loading").addClass("is-hide");
			$("body").css("overflow", "");
			startWebsiteAnimation();
		}, 1200);

	});

	// =========================
	// START WEBSITE
	// =========================
	function startWebsiteAnimation() {
		// Main visual animation
		setTimeout(function () {
			$(".p-frontVisual").addClass("is-active");
		}, 400);

		setTimeout(function () {
			$(".p-frontAnalyst").addClass("is-show");
		}, 400);

		// Counter animation
		let started = false;
		function counterAnimation() {
			$(".js-counter").each(function () {
				let $this = $(this);
				let target = parseFloat($this.data("target"));
				$({
					count: 0
				}).animate({
					count: target
				}, {
					duration: 2000,
					easing: "swing",
					step: function () {
						let value;
						if (target % 1 !== 0) {
							value = this.count.toFixed(1);
						} else {
							value = Math.ceil(this.count);
						}
						if (target == 99.9) {
							$this.text(value + "%");
						} else if (target == 24) {
							$this.text(value + "/7");
						} else {
							$this.text(value + "+");
						}
					},
					complete: function () {
						if (target == 99.9) {
							$this.text("99.9%");
						} else if (target == 24) {
							$this.text("24/7");
						} else {
							$this.text(target + "+");
						}
					}
				});
			});
		}
		function checkCounter() {
			let section = $(".p-frontAnalyst");
			if (!section.length || started) return;
			let top = section.offset().top;
			let scroll = $(window).scrollTop();
			let height = $(window).height();
			if (scroll + height > top + 100) {
				started = true;
				counterAnimation();
			}
		}
		$(window).on("scroll", checkCounter);
		checkCounter();
	}

});

jQuery(function ($) {
	function reasonAnimation() {
		var $target = $(".p-frontReason");
		if (!$target.length) {
			return;
		}
		var scrollTop = $(window).scrollTop();
		var windowH = $(window).height();
		var targetTop = $target.offset().top;

		if (
			scrollTop + windowH > targetTop + 200
		) {
			$target.addClass("is-show");
			$(window).off(
				"scroll",
				reasonAnimation
			);
		}
	}
	$(window).on(
		"scroll",
		reasonAnimation
	);

	reasonAnimation();
});

jQuery(function ($) {
	function mobileSubMenu() {
		$('.l-header-nav__item--parent > a').off('click');
		if ($(window).width() <= 767) {
			$('.l-header-nav__item--parent > a').on('click', function (e) {
				e.preventDefault();

				const parent = $(this).parent();
				const sub = parent.find('.l-header-nav__sub');

				parent.toggleClass('is-open');
				sub.stop().slideToggle(300);
			});

		}
	}

	mobileSubMenu();
	$(window).on('resize', function () {
		mobileSubMenu();
	});

});

jQuery(function ($) {
	if ($('body').hasClass('error404')) {
		$('.l-header-nav__item a').removeClass('active');
		return;
	}
	const currentPath = window.location.pathname.replace(/\/+$/, '');
	$('.l-header-nav__item a').each(function () {
		const href = $(this).attr('href');
		if (!href || href === '#') return;
		const url = new URL(href);
		const linkPath = url.pathname.replace(/\/+$/, '');
		if (currentPath === linkPath) {
			$(this).addClass('active');
		}

	});

});


jQuery(function ($) {
	new ScrollHint('.js-scrollHint', {
		scrollHintIconAppendClass: 'scroll-hint-icon-white',
		i18n: {
			scrollable: 'Vuốt để xem thêm'
		}
	});
});

jQuery(function ($) {
	const $window = $(window);
	const $floating = $('.js-floatingTrial');
	const $footer = $('.l-footer');

	function toggleFloatingTrial() {
		const scrollTop = $window.scrollTop();
		const scrollBottom = scrollTop + $window.height();

		$floating.toggleClass('is-show', scrollTop > 400);

		if ($footer.length && scrollBottom >= $footer.offset().top) {
			$floating.fadeOut(200);
		} else {
			$floating.fadeIn(200);
		}
	}

	$window.on('scroll resize', toggleFloatingTrial);

	toggleFloatingTrial();
});

jQuery(function ($) {

	$('.p-sessionEA__galleryLink').on('click', function (e) {
		e.preventDefault();

		var $img = $(this).find('img');

		$('.p-galleryModal__image')
			.attr('src', $img.attr('src'))
			.attr('alt', $img.attr('alt'));

		$('.p-galleryModal').addClass('is-active');
	});

	$('.p-galleryModal__close').on('click', function () {
		$('.p-galleryModal').removeClass('is-active');
	});

	$('.p-galleryModal').on('click', function (e) {
		if ($(e.target).is('.p-galleryModal')) {
			$(this).removeClass('is-active');
		}
	});

	$(document).on('keydown', function (e) {
		if (e.key === 'Escape') {
			$('.p-galleryModal').removeClass('is-active');
		}
	});

});
jQuery(function ($) {
	$('.p-guide__tab').on('click', function () {
		$('.p-guide__tab').removeClass('p-guide__tab--active');
		$(this).addClass('p-guide__tab--active');

	});
});
jQuery(function ($) {
	$('.c-sidebar__passwordCopy').on('click', function () {

		const target = $($(this).data('copy'));

		target.prop('readonly', false);
		target.select();
		target[0].setSelectionRange(0, 99999);

		document.execCommand('copy');

		target.prop('readonly', true);
		target.blur();

		alert('Đã sao chép mật khẩu!');
	});
});